/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
import { InviteUserProps } from "./components";
import { AppNavigatorService } from "../appNavigatorService";

const is = require("is_js");

const SERVICE_NAME = "InviteMasqueraderListPageService";
const log: any = LoggerModule.getInstance();

const getAppNavService = () => {
  const app = VApplication.getInstance();
  return app?.getSync("services.AppNavigatorService") as AppNavigatorService;
};

export class InviteMasqueraderListPageService {
  private static instance: InviteMasqueraderListPageService;
  private vapp: VApplication;
  private loginRestAPI: string;
  private criteria: any;
  private headers: any;
  private token: string;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
    this.loginRestAPI = props?.loginRestAPI;
    this.headers = props?.headers;
    this.token = props?.token;
  }

  public static getInstance(props: any = {}): InviteMasqueraderListPageService {
    if (!InviteMasqueraderListPageService.instance) {
      InviteMasqueraderListPageService.instance =
        new InviteMasqueraderListPageService(props);
    }
    return InviteMasqueraderListPageService.instance;
  }

  private setCriteria(data: any) {
    this.criteria = data;
  }

  public resetCriteria() {
    this.criteria = null;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getPageContent(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();
    const appNavSrv = getAppNavService();

    if (args?.criteria) {
      this.setCriteria(args?.criteria);
    }

    //Settings Props
    compProps = await agent.getSettingsProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    compProps = await agent.getPresentationListsProps();
    if (compProps) {
      content = { ...content, ...compProps };
    }

    // const { whoami } = await appNavSrv.whoAmI();
    // if (whoami === "admin") {
    //   compProps = await agent.getAdminPresentationListsProps();
    //   if (compProps) {
    //     content = { ...content, ...compProps };
    //   }
    // } else {
    //   compProps = await agent.getPresentationListsProps();
    //   if (compProps) {
    //     content = { ...content, ...compProps };
    //   }
    // }

    compProps = await agent.getUserListsWithBoxesProps({
      ...args,
      criteria: { ...this.criteria, ...args?.criteria },
    });
    if (compProps) {
      content = { ...content, ...compProps };
    }
    compProps = await agent.getDiscountOptionsProps({
      ...args,
    });
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getSingleRecall(args: any) {
    log.info(`invite user`, args);
    const agent = getAgent();
    return agent.getSingleRecallProps(args);
  }

  public async getPresentation(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.getPresentationListsProps();
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getInviteTable() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.getMyCommitteInviteStatusProps();
    if (compProps) {
      content = { ...content, ...compProps };
    }

    compProps = await agent.getInviteTableProps();
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getCommitteList(args: any) {
    const agent = getAgent();
    return agent.getcommitteListProps(args);
  }

  public async inviteUser(args: InviteUserProps) {
    log.info(`invite user`, args);
    const agent = getAgent();
    return agent.getInviteUser(args);
  }

  public async sendPurchaseInvite(args: any) {
    log.info(`sendPurchaseInvite user`, args);
    const agent = getAgent();
    return agent.sendPurchaseInviteUser(args);
  }

  public async sendSinglePurchaseInvite(args: any) {
    log.info(`sendSinglePurchaseInvite user`, args);
    const agent = getAgent();
    return agent.sendSinglePurchaseInviteUser(args);
  }

  public async sendDiscountUser(args: any) {
    log.info(`sendSinglePurchaseInvite user`, args);
    const agent = getAgent();
    return agent.sendDiscountUser(args);
  }

  public async recallInvite(args: any) {
    log.info(`recall user`, args);
    const agent = getAgent();
    return agent.recallInviteUser(args);
  }

  public async recallDiscountUser(args: any) {
    log.info(`recall user`, args);
    const agent = getAgent();
    return agent.recallDiscountUser(args);
  }

  public async reInvite(args: any) {
    log.info(`recall user`, args);
    const agent = getAgent();
    return agent.reInviteUser(args);
  }


  public async getSearchEmailContent(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();
    compProps = await agent.searchEmailProps(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async checkCountInvite() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();
    compProps = await agent.checkCountInvite();

    return compProps;
  }
}
